import React from "react";
import { Steps, Card, Modal } from "antd";
import { LoadingOutlined, UserOutlined, CreditCardOutlined, SettingOutlined } from "@ant-design/icons";
import useMediaQuery from "use-media-antd-query";
import { useTranslation } from "react-i18next";

const { Step } = Steps;

const isNullOrUndefinedOrEmpty = (value) => {
  return value === null || value === undefined || value === "";
};

const isIdentificationReady = (data, t) => {
  if (!data) return false;

  const identification = data?.identification;
  const customization = data?.customization;

  if (!identification) return false;

  if (isNullOrUndefinedOrEmpty(identification?.name)) {
    Modal.error({ title: t("steps.nameRequired") });
    return false;
  }

  if (isNullOrUndefinedOrEmpty(identification?.email)) {
    Modal.error({ title: t("steps.emailRequired") });
    return false;
  }

  //phone_required
  if (customization?.phone_required === true) {
    if (isNullOrUndefinedOrEmpty(identification?.phone)) {
      Modal.error({ title: t("steps.phoneRequired") });
      return false;
    }
  }

  //ask_vatid_on_checkout  and vatid_on_checkout_required
  if (customization?.ask_vatid_on_checkout === true && customization?.vatid_on_checkout_required === true) {
    if (isNullOrUndefinedOrEmpty(identification?.vatid)) {
      Modal.error({ title: t("steps.vatRequired") });
      return false;
    }
  }

  return true;
};

// Glyph color per step state: accent on active + completed badges,
// default gray (via CSS) on pending steps.
const stepIconColor = (status, accent) => {
  return status === "process" || status === "finish" ? accent : "";
};

const PaymentStatus = ({ statusAction, status, accent }) => {
  const color = stepIconColor(status, accent);
  if (statusAction === "wait-for-payment") {
    return <LoadingOutlined style={{ color }} />;
  }
  return <CreditCardOutlined style={{ color }} />;
};

/***********************************************************************************************
 ***********************************************************************************************
 ***********************************************************************************************
 * ##: APP
 ***********************************************************************************************
 ***********************************************************************************************
 **********************************************************************************************/
const StepsHeader = ({ step, data, actionHandler, customStyle }) => {
  const { t } = useTranslation();
  const statusAction = data?.status?.action;
  const colSize = useMediaQuery();
  // console.log("colSize", colSize); // "xs" | "sm" | "md" | "lg" | "xl" | "xxl"

  const style = customStyle["primary"];
  const accent = style?.backgroundColor || "#1890ff";

  const stepStatus = (step, stepIndex) => {
    if (statusAction === "paid") {
      if (stepIndex === 0) return "finish";
      if (stepIndex === 1) return "finish";
      if (stepIndex === 2) return "finish";
    }
    if (statusAction === "wait-for-payment") {
      if (stepIndex === 0) return "wait";
      if (stepIndex === 1) return "wait";
      if (stepIndex === 2) return "process";
    }

    if (stepIndex === 0 && step === 0) return "process";
    if (stepIndex === 1 && step === 0) return "wait";
    if (stepIndex === 2 && step === 0) return "wait";

    if (stepIndex === 0 && step === 1) return "finish";
    if (stepIndex === 1 && step === 1) return "process";
    if (stepIndex === 2 && step === 1) return "wait";

    if (stepIndex === 0 && step === 2) return "finish";
    if (stepIndex === 1 && step === 2) return "finish";
    if (stepIndex === 2 && step === 2) return "process";
  };

  if (data?.is_teaser === true) {
    return "";
  }

  return (
    <div style={{ marginBottom: 10, "--sp-accent": accent }}>
      {colSize !== "xs" && (
        <Card className="steps-container" size={colSize === "xs" ? "small" : "default"}>
          <Steps>
            <Step
              className="as-link"
              status={stepStatus(step, 0)}
              title={t("steps.identification")}
              icon={
                <UserOutlined style={{ color: stepIconColor(stepStatus(step, 0), accent) }} />
              }
              onClick={() => {
                if (statusAction !== "wait-for-payment" && statusAction !== "paid") {
                  actionHandler("move", 0);
                }
              }}
            />
            <Step
              className="as-link"
              status={stepStatus(step, 1)}
              title={t("steps.options")}
              icon={
                <SettingOutlined style={{ color: stepIconColor(stepStatus(step, 1), accent) }} />
              }
            />
            <Step
              className="as-link"
              status={stepStatus(step, 2)}
              title={t("steps.payment")}
              icon={<PaymentStatus statusAction={statusAction} status={stepStatus(step, 2)} accent={accent} />}
            />
          </Steps>
        </Card>
      )}

      {colSize === "xs" && (
        <div className="steps-container-mobile">
          <Steps type="default" responsive={false}>
            <Step
              className="as-link"
              status={stepStatus(step, 0)}
              title={t("steps.identification")}
              icon={
                <UserOutlined style={{ color: stepIconColor(stepStatus(step, 0), accent) }} />
              }
              onClick={() => {
                if (statusAction !== "wait-for-payment" && statusAction !== "paid") {
                  actionHandler("move", 0);
                }
              }}
            />

            <Step
              className="as-link"
              status={stepStatus(step, 1)}
              title={t("steps.options")}
              icon={
                <SettingOutlined style={{ color: stepIconColor(stepStatus(step, 1), accent) }} />
              }
            />
            <Step className="as-link" status={stepStatus(step, 2)} title={t("steps.payment")} icon={<PaymentStatus statusAction={statusAction} status={stepStatus(step, 2)} accent={accent} />} />
          </Steps>
        </div>
      )}
    </div>
  );
};

export default StepsHeader;
